import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class CanceledOrdersApi extends CrudBase {

  getCanceledOrders = (params) => axios.get(`${this.endpoint}/get-by`, params);

  defaultMethods = {
    ...this.defaultMethods,
    getCanceledOrders: this.getCanceledOrders,
  }
}

const canceledOrders = new CanceledOrdersApi('/api/v1/canceled-order');

export default canceledOrders.defaultMethods;

